import { getSearchParams } from '@wix/package-picker-shared';
import { useMemo } from 'react';
import { useCurrentModule } from '../components';
import { useReportQueryError } from './useReportQueryError';
import { useSwitchFlows } from './useSwitchFlows';
export const ECLIPSE_AI_PLAN_COPY_SPEC = 'eclipseAiPlanCopy';
export const useEclipseAiContent = () => {
  const module = useCurrentModule();
  const {
    experiments
  } = module.internals.experiments.hooks.useExperiments();
  const isAiContentSpecEnabled = experiments.isEnabled(ECLIPSE_AI_PLAN_COPY_SPEC);
  const {
    isUpgradeFlow,
    isSuccess: isFlowResolved
  } = useSwitchFlows();
  const {
    siteGuid,
    domainName,
    showDomain: showDomainParam,
    referralAdditionalInfo
  } = getSearchParams();
  const showDomain = showDomainParam === true && experiments.isEnabled('specs.premium.DisplayDomainNameInDomainFeature');
  const request = useMemo(() => ({
    siteGuid,
    isUpgrade: isUpgradeFlow,
    domain: domainName,
    showDomain,
    referral: referralAdditionalInfo
  }), [siteGuid, isUpgradeFlow, domainName, showDomain, referralAdditionalInfo]);
  const shouldFireAIContentQuery = isAiContentSpecEnabled && isFlowResolved;
  const reportQueryError = useReportQueryError();
  const {
    data: suggestion,
    isLoading: isQueryLoading
  } = module.SDK.aiContentApiClient.hooks.useGetAiPlanContent(request, shouldFireAIContentQuery, {
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    useErrorBoundary: false,
    onError: error => reportQueryError('getAiPlanContent', error)
  });
  const descriptionByTier = useMemo(() => {
    var _suggestion$tiers;
    const map = new Map();
    suggestion == null || (_suggestion$tiers = suggestion.tiers) == null || _suggestion$tiers.forEach(tier => {
      if (tier.descriptionShort) {
        map.set(tier.tier, tier.descriptionShort);
      }
    });
    return map;
  }, [suggestion]);
  return {
    pageTitle: isAiContentSpecEnabled ? suggestion == null ? void 0 : suggestion.pageTitle : undefined,
    getTierDescription: tier => isAiContentSpecEnabled ? descriptionByTier.get(tier) : undefined,
    isLoading: isAiContentSpecEnabled && isQueryLoading,
    isEnabled: isAiContentSpecEnabled
  };
};
//# sourceMappingURL=useEclipseAiContent.js.map